module.exports = __webpack_public_path__ + "static/img/1841_phase_function_Paper_Points.99c75da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1841_phase_function_Paper_Points.png
// module id = fzJy
// module chunks = 0